// $(document).ready(function () {
//   var productprice = $(".price-container__price").text();
//   console.log(productprice);
//   $(".quantity-button").click(function () {
//     var quantity = $(".quantity").val();
//     let afterquantityupdate = productprice * quantity;
//     $(".btn-container").attr("approve-qty", quantity);
//     // $(".btn_r_container .teaser").attr("approve-total", afterquantityupdate);
//     console.log(afterquantityupdate);
//   });
// });

$(document).ready(function () {
    $(document).find('a').each(function(){
        var newHref = $(this).attr('href').replace('https://touchamerica.myshopify.com', 'https://www.touchamerica.com');
        $(this).attr('href', newHref);
    });
});